import { lazy } from "react";
const Broker = lazy(() => import("../../views/news/broker"));
const BrokerProfile = lazy(() =>
  import("../../views/news/broker/BrokerProfile")
);

const BrokerRoutes = [
  {
    element: <Broker />,
    path: "/broker",
  },
  {
    element: <BrokerProfile />,
    path: "/broker/broker-profile/:id",
  },
];

export default BrokerRoutes;
